export const SEARCH_REQUEST_TYPE_ASYNC = 'SEARCH_REQUEST_TYPE_ASYNC';
export const SEARCH_REQUEST_TYPE_SUCCESS = 'SEARCH_REQUEST_TYPE_SUCCESS';

export const CHECK_BEFORE_UPDATE_REQUEST_TYPE_ASYNC = 'CHECK_BEFORE_UPDATE_REQUEST_TYPE_ASYNC';
export const CREATE_REQUEST_TYPE_ASYNC = 'CREATE_REQUEST_TYPE_ASYNC';
export const UPDATE_REQUEST_TYPE_ASYNC = 'UPDATE_REQUEST_TYPE_ASYNC';

export const MAKE_ACTIVE_REQUEST_TYPE_ASYNC = 'MAKE_ACTIVE_REQUEST_TYPE_ASYNC';
export const MAKE_INACTIVE_REQUEST_TYPE_ASYNC = 'MAKE_INACTIVE_REQUEST_TYPE_ASYNC';

export const CHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC = 'CHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC';
export const UNCHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC = 'UNCHECK_PRE_ORIENTATION_REQUEST_TYPE_ASYNC';

export const CHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC = 'CHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC';
export const UNCHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC = 'UNCHECK_FROM_HOME_OWNER_REQUEST_TYPE_ASYNC';

export const OPEN_FORM_CREATE_REQUEST_TYPE = 'OPEN_FORM_CREATE_REQUEST_TYPE';
export const CLOSE_FORM_CREATE_REQUEST_TYPE = 'CLOSE_FORM_CREATE_REQUEST_TYPE';

export const GET_REQUEST_TYPE_BY_ID_ASYNC = 'GET_REQUEST_TYPE_BY_ID_ASYNC';
export const GET_REQUEST_TYPE_BY_ID_SUCCESS = 'GET_REQUEST_TYPE_BY_ID_SUCCESS';

export const ADD_EDIT_REQUEST_TYPE_ERROR = 'ADD_EDIT_REQUEST_TYPE_ERROR';
export const RESET_REQUEST_TYPE = 'RESET_REQUEST_TYPE';

export const SELECT_LIST_ITEM_ASYNC = 'SELECT_LIST_ITEM_ASYNC';
export const SELECT_LIST_ITEM_SUCCESS = 'SELECT_LIST_ITEM_SUCCESS';

export const GET_HOMEOWNER_REQUEST_TYPE_LIST_ASYNC = 'GET_HOMEOWNER_REQUEST_TYPE_LIST_ASYNC';
export const GET_HOMEOWNER_REQUEST_TYPE_LIST_SUCCESS = 'GET_HOMEOWNER_REQUEST_TYPE_LIST_SUCCESS';




// WEBPACK FOOTER //
// ./src/Request-Types/constants.js